<main class="main main_activity {{this.model?.activityCode}}"
      [ngClass]="{
          'main_sticky': isLoaded && model && model.subtitle,
          'with-vertical-progress-indicator': isVerticalProgress,
          'family-history': this.model?.activityCode === 'FAMILY_HISTORY'
      }"
>
    <section class="section">
        <ddp-subject-panel *ngIf="selectedUser$ | async as selectedUser" [subject]="selectedUser"></ddp-subject-panel>
        <ddp-admin-action-panel *ngIf="isLoaded && model"
            [activityReadonly]="isReadonly()"
            (requestActivityEdit)="updateIsAdminEditing($event)">
        </ddp-admin-action-panel>
    </section>
    <ng-container *ngIf="isLoaded && model">
        <section *ngIf="model.subtitle" class="section sticky-section"
                 [ngClass]="{'sticky-section_shadow': isScrolled}">
            <div class="content content_tight">
                <div class="sticky-block" [innerHTML]="model.subtitle"></div>
            </div>
        </section>
        <section *ngIf="model.title" class="section header-section">
            <div class="content content_tight">
                <h1 class="activity-header" [innerHTML]="model.title"></h1>
            </div>
        </section>
    </ng-container>

    <!-- article content -->
    <section *ngIf="isLoaded; else spinner" class="section article-content">
        <ng-container *ngIf="isVerticalProgress && isStepped && showStepper; then verticalProgressIndicator;">
        </ng-container>

        <div class="content content_tight">
            <ng-container *ngIf="shouldShowReadonlyHint">
                <div class="infobox" [innerHTML]="model.readonlyHint">
                </div>
            </ng-container>
            <!-- introduction section -->
            <!-- Check model not null and not undefined. Open to race condition -->
            <ng-container *ngIf="model && model.introduction">
                <ddp-activity-section
                    [section]="model.introduction"
                    [readonly]="isReadonly() || dataEntryDisabled"
                    [validationRequested]="validationRequested"
                    [studyGuid]="studyGuid"
                    [activityGuid]="activityGuid"
                    (embeddedComponentsValidationStatus)="updateEmbeddedComponentValidationStatus(0, $event)"
                    (componentBusy)="embeddedComponentBusy$[0].next($event)">
                </ddp-activity-section>
            </ng-container>

            <ng-container *ngIf="isStepped && showStepper">
                <ng-container *ngIf="!isVerticalProgress; then horizontalProgressIndicator">
                </ng-container>
            </ng-container>

            <ng-container *ngIf="model">
                <ddp-activity-section
                    [section]="currentSection"
                    [readonly]="isReadonly() || dataEntryDisabled"
                    [validationRequested]="validationRequested"
                    [studyGuid]="studyGuid"
                    [activityGuid]="activityGuid"
                    (embeddedComponentsValidationStatus)="updateEmbeddedComponentValidationStatus(1, $event)"
                    (componentBusy)="embeddedComponentBusy$[1].next($event)">
                </ddp-activity-section>

                <!-- closing section -->
                <ng-container *ngIf="model.closing">
                    <ddp-activity-section
                        [section]="model.closing"
                        [readonly]="isReadonly() || dataEntryDisabled"
                        [validationRequested]="validationRequested"
                        [studyGuid]="studyGuid"
                        [activityGuid]="activityGuid"
                        (embeddedComponentsValidationStatus)="updateEmbeddedComponentValidationStatus(2, $event)"
                        (componentBusy)="embeddedComponentBusy$[2].next($event)">
                    </ddp-activity-section>
                </ng-container>

                <ng-container *ngIf="shouldShowReadonlyHint">
                    <div class="infobox" [innerHTML]="model.readonlyHint"></div>
                </ng-container>

                <ng-container *ngIf="model.lastUpdatedText">
                    <span class="last-updated">{{model.lastUpdatedText}} </span>
                </ng-container>

                <div class="activity-buttons" *ngIf="activityGuid"
                     [ngClass]="{'activity-buttons_mobile': (!isStepped || isLastStep) && isAgree() && isLoaded && !isReadonly()}">
                    <ng-container *ngIf="isLoaded && isStepped; then navigationButtons"></ng-container>
                    <ng-container *ngIf="(!isStepped || isLastStep) && isLoaded; then lastStepButtons"></ng-container>
                    <ng-container
                        *ngIf="(!isStepped || isLastStep) && isAgree() && isLoaded && !isReadonly(); then agreementButtons">
                    </ng-container>
                </div>

                <div *ngIf="displayGlobalError$ | async" class="ErrorMessage">
                    <span translate>SDK.ValidateError</span>
                </div>
                <div *ngIf="communicationErrorOccurred" class="ErrorMessage">
                    <span translate>SDK.CommunicationError</span>
                </div>
            </ng-container>
        </div>
    </section>
</main>

<!--------------------------Used templates------------------------------>
<ng-template #spinner>
    <section class="section section-spinner">
        <mat-spinner></mat-spinner>
    </section>
</ng-template>

<ng-template #stepsWithCircle>
    <div class="activity-steps" [ngClass]="{'vertical': isVerticalProgress}">
        <ng-container *ngFor="let section of model.sections; index as i; last as isLastStep">
            <ng-container *ngIf="section.visible">
                <div class="activity-step" cdkMonitorElementFocus
                     [attr.tabindex]="isVerticalProgress && (isActive(i) || isCompleted(i)) ? 1 : null"
                     (click)="jumpStep(i)"
                     [class.active]="isActive(i)"
                     [class.completed]="isCompleted(i)">
                    <span class="activity-step__number">{{i + 1}}</span>
                    <span class="activity-step__text">{{section.name}}</span>
                </div>
                <div *ngIf="!isLastStep" class="activity-steps__divider"></div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #simpleSteps>
    <div class="activity-steps">
        <ng-container *ngFor="let section of model.sections; index as i">
            <ng-container *ngIf="section.visible">
                <p class="activity-step no-margin big bold"
                   (click)="jumpStep(i)"
                   [class.active]="isActive(i)"
                   [class.completed]="isCompleted(i)">
                    {{section.name}}
                </p>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #navigationButtons>
    <button *ngIf="!isFirstStep"
            [disabled]="(isPageBusy | async) || dataEntryDisabled"
            class="button button_secondary previous_button"
            [ngClass]="isVerticalProgress? 'button_small' : 'button_medium'"
            (click)="decrementStep()"
            [innerHTML]="'SDK.PreviousButton' | translate">
    </button>
    <button *ngIf="!isLastStep"
            [disabled]="(isPageBusy | async) || dataEntryDisabled"
            class="button button_right next_button"
            [ngClass]="isVerticalProgress? 'button_secondary button_small' : 'button_primary button_medium'"
            (click)="incrementStep()"
            [innerHTML]="(isPageBusy | async) ? ('SDK.SavingButton' | translate) : ('SDK.NextButton' | translate)">
    </button>
</ng-template>

<ng-template #lastStepButtons>
    <button *ngIf="!isReadonly() && !isAgree()" #submitButton
            [disabled]="(isPageBusy | async) || dataEntryDisabled"
            class="button button_right submit_button"
            [ngClass]="isVerticalProgress? 'button_secondary button_small' : 'button_primary button_medium'"
            (click)="flush()"
            (mouseenter)="mouseEnterOnSubmit()"
            [innerHTML]="(isPageBusy | async) ? ('SDK.SavingButton' | translate) :
              ( (isVerticalProgress? 'SDK.FinishButton' : 'SDK.SubmitButton') | translate)">
    </button>
    <button *ngIf="isReadonly()"
            class="button button_medium button_primary button_right close_button"
            (click)="close()"
            [innerHTML]="'SDK.CloseButton' | translate">
    </button>
</ng-template>

<ng-template #agreementButtons>
    <button class="button button_medium button_warn"
            [disabled]="(isPageBusy | async) || dataEntryDisabled"
            (click)="close()">
        <mat-icon class="button__icon">highlight_off</mat-icon>
        {{'SDK.NotAgreeButton' | translate}}
    </button>
    <button #submitButton
            [disabled]="(isPageBusy | async) || dataEntryDisabled"
            class="button button_medium button_primary"
            (click)="flush()"
            (mouseenter)="mouseEnterOnSubmit()">
        <mat-icon *ngIf="!(isPageBusy | async)" class="button__icon">check_circle_outline</mat-icon>
        {{(isPageBusy | async) ? ('SDK.SavingButton' | translate) : ('SDK.AgreeButton' | translate)}}
    </button>
</ng-template>

<ng-template #verticalProgressIndicator>
    <ng-container *ngTemplateOutlet="stepsWithCircle"></ng-container>
</ng-template>

<ng-template #horizontalProgressIndicator>
    <ng-container *ngIf="useStepsWithCircle; then stepsWithCircle else simpleSteps"></ng-container>
</ng-template>
